import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';

// Só ilustração: o ícone sai do nome que a pessoa deu ao método
const ICON_RULES = [
  { test: /pix/, Icon: QrCode2OutlinedIcon },
  { test: /cart[aã]o|cr[eé]dito|d[eé]bito|card/, Icon: CreditCardOutlinedIcon },
  { test: /dinheiro|esp[eé]cie|cash/, Icon: PaymentsOutlinedIcon },
  { test: /boleto/, Icon: ReceiptOutlinedIcon },
  { test: /transfer|\bted\b|\bdoc\b|dep[oó]sito|banco/, Icon: AccountBalanceOutlinedIcon },
];

/** Ícone do método de pagamento a partir do nome (carteira quando nada combina). */
export const methodIcon = (label) => {
  const name = String(label || '').toLowerCase();
  const rule = ICON_RULES.find((r) => r.test.test(name));
  return rule ? rule.Icon : AccountBalanceWalletOutlinedIcon;
};

/** Lê o ajuste digitado ("2,5", "-10", "") como número; vazio vira 0 e texto inválido vira NaN. */
export const parseModifier = (value) => {
  const text = String(value ?? '').trim().replace(',', '.');
  if (text === '' || text === '-') return 0;
  return /^-?\d*\.?\d*$/.test(text) ? Number(text) : NaN;
};

const formatPercent = (number) => String(number).replace('.', ',');

/** Selo do modificador: desconto (negativo), acréscimo (positivo) ou sem ajuste. */
export const modifierTag = (value) => {
  const number = parseModifier(value) || 0;
  if (number < 0) return { tone: 'discount', text: `${formatPercent(number)}% desconto` };
  if (number > 0) return { tone: 'increase', text: `+${formatPercent(number)}% acréscimo` };
  return { tone: 'neutral', text: 'Sem ajuste' };
};
